import { Button, Col, Row, Checkbox, Modal, Radio, Form, Space } from "antd";
import styles from "./landingDetails.module.scss";
import TimeDown from "../../../components/timedown/timedown";
import styled from "styled-components";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useAPIPublic, useSecurity, useTenders } from "../../../tools/api";
import { useEffect, useRef, useState } from "react";
import { complexDigitToman, convertToJalaliWithTime, isEmpty, isEmptyObject, validateInput } from "../../../tools/tools";
import TenderBidders from "./tableBidders";
import PolicyModal, { AlertTenderModal, ModalFactor, PreFactor } from "./modal/policyModal";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../../address";
import { CheckToken, getSessionStorage, setLocalStorage, setSessionStorage } from "../../../tools/services";
import { useDispatch, useSelector } from "react-redux";
import Layouts, { useLayouts } from "../../layout/layouts";
import WihtoutDetailLogin from "./without-login/wo-login";
import InCreaseWallet from "../../../components/increaseWallet/InCreaseWallet";
import { useTranslation } from "react-i18next";
import Loading from "../../../components/loader/loading";
import WinnerModal from "./winner/winner-modal";
import { globalValue } from "../../../reducer/serviceReducerGlobala";

const LangingDetails = () => {
	const [t] = useTranslation("global");
	const { _currentUser } = useSelector((state) => {
		return state?.another;
	});

	const dispatch = useDispatch();

	const [frmBids] = Form.useForm();

	const { querySummerOfTenderBidders, queryTenderNumberById, SubmitBidInTender, userPaidDeposit } = useTenders();
	const { freezeWalletAmount } = useSecurity();
	const { queryCurrentUser } = useAPIPublic();
	const location = useLocation();
	const nav = useNavigate();
	const queryString = new URLSearchParams(location.search);

	const { refreshUser, checkLoginUser } = useLayouts();

	const [searchParam] = useSearchParams();

	const [id, setId] = useState(queryString.get("id"));

	//loading.....
	const [isLoading, setIsLoading] = useState(false);

	//check Login
	const [isLogin, setLogin] = useState(false);
	//user Info
	const [user, setUser] = useState({});

	const [queryTender, setQueryTender] = useState({});
	const [bidders, setBidders] = useState([]);
	const [summeryTenders, setSummeryTenders] = useState({});

	//list bids For Prefer
	const [bidsPrice, setBidsPrice] = useState([]);
	//get Amount Bid From Prefer
	const [bidAmount, setBidAmount] = useState("0");

	//accept Policy
	const [accept, setAccept] = useState(true);

	//id call back banks
	const [localInvoiceId, setLocalInvoiceId] = useState("");

	//check For Prefer Bide
	const [activeBide, setActiveBide] = useState(false);
	const [activatedBide, setActivatedBide] = useState(false);
	//choose value
	const [valueBide, setValueBide] = useState(-1);

	//check finish auction and bids

	const [finishBid, setFinishBid] = useState(false);

	//state open modal
	const [isOpenModalPolicy, setIsOpenModalPolicy] = useState(false);
	const [isOpenTenderModal, setIsOpenTenderModal] = useState(false);
	const [isOpenModalIncreaseCharge, setIsOpenModalIncreaseCharge] = useState(false);
	const [isOpenModalAcceptFactor, setIsOpenModalAcceptFactor] = useState(false);
	const [isOpenModalFactor, setIsOpenModalFactor] = useState(false);
	const [isOpenWinnerModal, setIsOpenWinnerModal] = useState(false);

	//state query id
	const [tenderID, setTenderID] = useState(localStorage.getItem("tenderID") || "0");

	//ref
	const bankRef = useRef("");

	const [isCallService, setIsCallService] = useState(false);

	useEffect(() => {
		if (!isEmpty(searchParam.get("localInvoiceId"))) {
			const getLocalInvoiceID = searchParam.get("localInvoiceId");
			setLocalInvoiceId(getLocalInvoiceID);
			setIsOpenModalIncreaseCharge(true);
		}
	}, []);

	useEffect(() => {
		const checkLogin = async () => {
			const isCheck = await checkLoginUser();
			if (isCheck) {
				setLogin(isCheck);
				const userInfo = await refreshUser();
				setUser(userInfo || {});
			}
			setIsCallService(true);
		};
		checkLogin();
	}, [checkLoginUser, refreshUser]);

	useEffect(() => {
		if (isCallService) {
			intialData();
		}
	}, [isCallService]);

	const intialData = async () => {
		try {
			debugger;
			setIsLoading(true);
			let getID = 0;
			if (isEmpty(id)) {
				getID = await getSessionStorage("id");
				setId(getID);
			} else {
				getID = id;
			}

			if (!isEmpty(getID)) {
				///Query Tender Bidders

				setSessionStorage("id", getID);

				setTenderID(getID);

				const payloadSummerOfTender = {
					auctionproductid: getID,
				};
				const responseSummer = await querySummerOfTenderBidders(payloadSummerOfTender);
				if (responseSummer) {
					setSummeryTenders(responseSummer);
				}

				const resTNumber = await queryTenderNumberById(getID);
				if (resTNumber) {
					setQueryTender(resTNumber);
					if (resTNumber.userBid > 0) {
						setActiveBide(true);
						setActivatedBide(true);
					}
					let list = [];
					if (resTNumber.maxBid > 0) {
						list = generatePrice(resTNumber?.maxBid, resTNumber?.priceJump, resTNumber?.showPriceJump);
					} else {
						list = generatePrice(resTNumber?.startPrice, resTNumber?.priceJump, resTNumber?.showPriceJump);
					}
					setBidsPrice(list);

					if (isLogin) {
						const depositPayload = {
							auctionproductofferid: getID,
						};
						const checkDeposit = await userPaidDeposit(depositPayload);
						if (checkDeposit?.Result) {
							setActiveBide(true);
						}
					}
					if ([0, 2, 3, 5, 6].includes(resTNumber?.auctionStatus) && new Date(resTNumber?.endDate) <= new Date()) {
						setFinishBid(true);
					}
				}
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	const handleCallBackAcceptModal = async (value) => {
		try {
			debugger;
			setIsLoading(true);
			setIsOpenTenderModal(false);
			if (value) {
				setActiveBide(true);
				const payload = {
					amount: queryTender?.tenderDeposit,
					planid: 30357,
					reasonchargingid: id,
				};
				const response = await freezeWalletAmount(payload);
				if (response && !response?.HasError) {
					refreshUser(true);
				} else {
					setIsOpenTenderModal(true);
				}
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	const generatePrice = (basePrice, jumpPrice, showJump) => {
		let retPrice = [];
		let price = basePrice;
		for (let i = 1; i <= showJump; i++) {
			price += jumpPrice;
			retPrice.push(price);
		}
		return retPrice;
	};

	const handleBackCharge = (value) => {
		setIsOpenModalIncreaseCharge(false);
		if (value) {
			localStorage.removeItem("tenderID");
			setLocalStorage("tenderID", tenderID);
			bankRef.current.innerHTML = value;
			document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
		}
	};

	const handleSubmitBids = async (value) => {
		setIsOpenModalAcceptFactor(true);
		setBidAmount(value?.amount);
	};

	const handleCallBackAcceptFactor = async (value) => {
		try {
			setIsOpenModalAcceptFactor(false);
			setIsLoading(true);
			if (value) {
				const payload = {
					auctionproductofferid: queryTender?.auctionProductId,
					amount: bidAmount,
				};
				const response = await SubmitBidInTender(payload);
				if (response && !response?.HasError) {
					setIsOpenModalFactor(true);
				} else if (response.Code === 1190) {
					intialData();
				}
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	const handleCallBackFactor = (value) => {
		setIsOpenModalFactor(false);
		nav(_adr.Root + _adr.Landing.Index);
	};
	const handleCallBackWinner = (value) => {
		setIsOpenWinnerModal(false);
	};

	const switchTagBag = (type = 0) => {
		switch (type) {
			case 0:
				return styles.gold;
			case 1:
				return styles.platinum;
			case 2:
				return styles.silver;
			case 3:
				return styles.bronze;
			case 4:
				return styles.aptel;
			default:
				return "";
		}
	};

	const Holder_button = styled.div`
		direction: ltr;
	`;

	return (
		<>
			<div className={styles.detailsOfNumber}>
				<div className={styles.holderDetailMsisdn}>
					<div className={`${styles.header}  ${switchTagBag(queryTender?.auctionProductTypeiId)}`}>
						<div className={styles.rowItem}>
							<div className={styles.holdMsisdn}>
								<div className={`${styles.tagType} ${switchTagBag(queryTender?.auctionProductTypeiId)}`}>{queryTender?.auctionProductType}</div>
								<div className={styles.msisdn}>
									<h3>{queryTender?.auctionTitle}</h3>
									<span>{queryTender?.bundle?.bundleName}</span>
								</div>
							</div>
							<div className={styles.holdCounter}>
								<TimeDown responsive datetime={new Date(queryTender?.endDate || "")} />
							</div>
						</div>
					</div>
					<div className={styles.body}>
						<div className={styles.rowBody}>
							<div className={styles.detailPrice}>
								<ul>
									<li>
										<div className={styles.label}>قیمت شروع:</div>
										<div className={styles.value}>
											<span>{complexDigitToman(queryTender?.startPrice)}</span> تومان
										</div>
									</li>
									<li>
										<div className={styles.label}>بالاترین پیشنهاد:</div>
										<div className={styles.value}>
											<span>{complexDigitToman(queryTender?.maxBid)} </span> تومان
										</div>
									</li>
									<li>
										<div className={styles.label}>تعداد شرکت کنندگان:</div>
										<div className={styles.value}>{summeryTenders?.bidders}</div>
									</li>
									<li>
										<div className={styles.label}>تعداد پیشنهادها:</div>
										<div className={styles.value}>{summeryTenders?.bids}</div>
									</li>
								</ul>
							</div>
							<div className={styles.divider}></div>
							{isLogin ? (
								<>
									{finishBid ? (
										<>
											<div className={styles.detailPrefer}>
												<ul>
													<li>
														<div className={styles.label}>ودیعه مورد نیاز جهت پیشنهاد:</div>
														<div className={styles.value}>
															<span>{complexDigitToman(queryTender?.tenderDeposit)}</span> تومان
														</div>
													</li>
													<li>
														<div className={styles.label}> مبلغ افزایش پلکانی:</div>
														<div className={styles.value}>
															<span>{complexDigitToman(queryTender?.priceJump)}</span> تومان
														</div>
													</li>
													<li>
														<div className={styles.label}> تاریخ شروع:</div>
														<div className={styles.value}>
															<span>{convertToJalaliWithTime(queryTender?.startDate)}</span>
														</div>
													</li>
													<li>
														<div className={styles.label}> تاریخ پایان:</div>
														<div className={styles.value}>
															<span>{convertToJalaliWithTime(queryTender?.endDate)}</span>
														</div>
													</li>
												</ul>
											</div>
										</>
									) : (
										<>
											{!activeBide ? (
												<div className={styles.detailPrefer}>
													<ul>
														<li>
															<div className={styles.label}>ودیعه مورد نیاز جهت پیشنهاد:</div>
															<div className={styles.value}>
																<span>{complexDigitToman(queryTender?.tenderDeposit)}</span> تومان
															</div>
														</li>
														<li>
															<div className={styles.label}>موجودی اعتبار:</div>
															<div className={styles.value}>
																<span>{complexDigitToman(_currentUser?.walletAmount)}</span> تومان
															</div>
														</li>
														<li>
															<div className={styles.label}>مبلغ قابل پرداخت:</div>
															<div className={styles.value}>
																<span>{complexDigitToman(queryTender?.tenderDeposit)}</span> تومان
															</div>
														</li>
													</ul>
												</div>
											) : (
												<>
													<div className={styles.detailPrefer}>
														<ul>
															<li>
																{activatedBide ? (
																	<div className={styles.label}>رقم پیشنهادی جدید:</div>
																) : (
																	<div className={styles.label}>رقم های پیشنهادی شما:</div>
																)}
																<div className={styles.value}>
																	<div className={styles.holder_prefer}>
																		<style>
																			{`
                                    .ant-radio-wrapper.ant-radio-wrapper-rtl {
                                      direction:ltr;
                                    }
                                  `}
																		</style>
																		<Form layout="vertical" form={frmBids} id="frmBids" onFinish={handleSubmitBids}>
																			<Form.Item name="amount" required rules={[validateInput({ t: t, validate: true })]}>
																				<Radio.Group
																					onChange={(e) => {
																						setValueBide(e.target.value);
																					}}
																					value={valueBide}>
																					<Space direction="vertical">
																						{bidsPrice.map((item, key) => (
																							<Radio key={key} value={item}>
																								<span>{complexDigitToman(item)}</span> تومان
																							</Radio>
																						))}
																					</Space>
																				</Radio.Group>
																			</Form.Item>
																		</Form>
																	</div>
																</div>
															</li>
														</ul>
													</div>
												</>
											)}
										</>
									)}
								</>
							) : (
								<>
									<div className={styles.detailPrefer}>
										<ul>
											<li>
												<div className={styles.label}>ودیعه مورد نیاز جهت پیشنهاد:</div>
												<div className={styles.value}>
													<span>{complexDigitToman(queryTender?.tenderDeposit)}</span> تومان
												</div>
											</li>
										</ul>
									</div>
								</>
							)}
						</div>
						{!finishBid && (
							<div className={!isLogin ? styles.holdFooterBody : styles.holdFooterBodyLogin}>
								{isLogin ? (
									<>
										<Row gutter={30}>
											<Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
												{!activeBide ? (
													<>
														{_currentUser?.walletAmount - queryTender?.tenderDeposit >= 0 ? (
															<div className={styles.holder_policy}>
																<Checkbox onChange={(e) => (e.target.checked ? setAccept(false) : setAccept(true))}>
																	قوانین و مقررات را مطالعه کرده و قبول دارم
																</Checkbox>
																<Link onClick={(e) => setIsOpenModalPolicy(true)} className={styles.heyper}>
																	مشاهده قوانین و مقررات
																</Link>
															</div>
														) : (
															<>
																<p data-color="red">موجودی کیف پول شما برای ودیعه کافی نمی‌باشد.</p>
															</>
														)}
													</>
												) : (
													<>
														<p>
															در صورتی که برنده مزایده شده باشید و از پرداخت ما به تفاوت مبلغ نهایی و ودیعه امتناع نمایید، مبلغ ودیعه شما نزد آپتل ضبط
															خواهد گردید.
														</p>
													</>
												)}
											</Col>
											<Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
												<div className={styles.holder_accept}>
													<div className={`holder-button ${styles.holderButton}`}>
														{!activeBide ? (
															<>
																{_currentUser?.walletAmount - queryTender?.tenderDeposit >= 0 ? (
																	<Button
																		onClick={() => {
																			setIsOpenTenderModal(true);
																		}}
																		disabled={accept}
																		className={`btn-aptel ${styles.btn_cerv}`}>
																		پرداخت ودیعه و ارايه پیشنهاد
																	</Button>
																) : (
																	<Button
																		onClick={() => {
																			setIsOpenModalIncreaseCharge(true);
																		}}
																		className={`btn-aptel ${styles.btn_cerv}`}>
																		افزایش موجودی
																	</Button>
																)}
															</>
														) : activatedBide ? (
															<Button form="frmBids" key={frmBids} htmlType="submit" className={`btn-green ${styles.btn_cerv}`}>
																ارایه پیشنهاد جدید
															</Button>
														) : (
															<Button form="frmBids" key={frmBids} htmlType="submit" className={`btn-aptel ${styles.btn_cerv}`}>
																ارایه پیشنهاد
															</Button>
														)}
													</div>
												</div>
											</Col>
										</Row>
									</>
								) : (
									<>
										<Holder_button className="holder-button">
											<Button onClick={(e) => nav(_adr.Root + _adr.Security.Login)} className={`btn-aptel ${styles.btnAptel}`}>
												شرکت در حراجی
											</Button>
										</Holder_button>
									</>
								)}
							</div>
						)}
					</div>
				</div>
				<div className={styles.participants}>
					<div className={styles.rowParticipants}>
						<div className={styles.title}>
							<h2>شرکت کنندگان</h2>
						</div>
						<div className={styles.preferPrice}>
							<div className={styles.tagName}>بالاترین پیشنهاد: {complexDigitToman(summeryTenders?.highestBid)} تومان</div>
						</div>
					</div>
					<div className={styles.BodyParticipants}>
						<TenderBidders bidders={bidders} tenderid={tenderID} />
					</div>
				</div>
			</div>

			<WinnerModal open={isOpenWinnerModal} callback={handleCallBackWinner} />
			<ModalFactor open={isOpenModalFactor} factor={{ ...queryTender, bidAmount }} callback={handleCallBackFactor} />
			<PreFactor open={isOpenModalAcceptFactor} factor={{ ...queryTender, bidAmount }} callback={handleCallBackAcceptFactor} />

			{/* پرداخت ودیعه بابت شرکت در حراجی */}
			<AlertTenderModal open={isOpenTenderModal} price={queryTender?.tenderDeposit} callback={handleCallBackAcceptModal} />
			{/* نمایش مقررات شرکت در حراجی */}
			<PolicyModal open={isOpenModalPolicy} callback={() => setIsOpenModalPolicy(false)} />
			<InCreaseWallet
				open={isOpenModalIncreaseCharge}
				msisdn={_currentUser?.telnoone || 0}
				planid={process.env.REACT_APP_INCREASE_DEPOSIT}
				price={queryTender?.tenderDeposit || 0}
				localInvoiceId={localInvoiceId}
				callback={handleBackCharge}
				activePrice={true}
			/>
			<div ref={bankRef}></div>
			<Loading isOpen={isLoading} />
		</>
	);
};

export default LangingDetails;
